module.exports = __webpack_public_path__ + "static/media/profile.ff1169b1.jpg";